import React, { createContext, useState, useContext } from "react";

const BlogContext = createContext(); // Create context

export const BlogProvider = ({ children }) => {
    const [selectedBlog, setSelectedBlog] = useState(null);

    return (
        <BlogContext.Provider value={{ selectedBlog, setSelectedBlog }}>
            {children}
        </BlogContext.Provider>
    );
};

// Custom hook to use BlogContext
export const useBlog = () => {
    const context = useContext(BlogContext);
    if (!context) {
        throw new Error("useBlog must be used within a BlogProvider");
    }
    return context;
};
